import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import _settings from '../services/settings.service.js';

const CONTACT_EMAIL = 'contact@gotasoft.io';
const LAST_UPDATED = '10 de julio de 2026';

export default function TermsOfServiceScreen() {
	const [companyName, setCompanyName] = useState('');

	useEffect(() => {
		const fetchCompanyName = async () => {
			try {
				const { data } = await _settings.listPublic();
				setCompanyName(data?.companyName || '');
			} catch (err) {
				// El nombre de la empresa solo se usa como texto; la página funciona igual sin él.
			}
		};
		fetchCompanyName();
	}, []);

	const appName = companyName || 'la Aplicación';
	const companyLabel = companyName || 'la Empresa';

	return (
		<div className='container mt-4 mb-5' style={{ maxWidth: '900px' }}>
			<Helmet title='Términos y Condiciones' />
			<h1>Términos y Condiciones</h1>
			<p><em>Última actualización: {LAST_UPDATED}</em></p>

			<p>
				Por favor lea estos Términos y Condiciones (&quot;Términos&quot;) cuidadosamente antes de usar {appName}{' '}
				(el &quot;Servicio&quot;) operado por {companyLabel} (&quot;la Empresa&quot;, &quot;Nosotros&quot; o
				&quot;Nuestro/a&quot;).
			</p>
			<p>
				Su acceso y uso del Servicio está condicionado a Su aceptación y cumplimiento de estos Términos. Al acceder
				o usar el Servicio, Usted acepta quedar sujeto a estos Términos. Si Usted no está de acuerdo con alguna
				parte de estos Términos, entonces no podrá acceder al Servicio.
			</p>

			<h2>Aceptación de los Términos</h2>
			<p>
				Al crear una cuenta, iniciar sesión, o de otra forma acceder o usar el Servicio, Usted confirma que ha
				leído, entendido y acepta quedar sujeto a estos Términos, así como a Nuestra Política de Privacidad. Si
				Usted está usando el Servicio en nombre de una organización, Usted declara que tiene la autoridad para
				vincular a dicha organización a estos Términos.
			</p>

			<h2>Descripción del Servicio</h2>
			<p>
				El Servicio provee herramientas para administrar cuentas, contactos, créditos, deudas, pagos, contratos y
				registros financieros y administrativos relacionados. Podemos agregar, cambiar o eliminar funciones o
				funcionalidades del Servicio en cualquier momento, con o sin previo aviso.
			</p>

			<h2>Cuentas</h2>
			<p>
				Cuando Usted crea una cuenta con Nosotros, debe proporcionar información precisa, completa y actualizada
				en todo momento. El incumplimiento de esto constituye una violación de los Términos, lo que puede resultar
				en la terminación inmediata de Su cuenta.
			</p>
			<p>
				Usted es responsable de proteger la contraseña y cualquier credencial que use para acceder al Servicio, y
				de cualquier actividad o acción bajo Su cuenta. Usted acepta no divulgar Su contraseña a terceros. Debe
				notificarnos de inmediato al tomar conocimiento de cualquier violación de seguridad o uso no autorizado de
				Su cuenta.
			</p>

			<h2>Uso Aceptable</h2>
			<p>Usted acepta no usar el Servicio:</p>
			<ul>
				<li>De ninguna forma que viole cualquier ley o normativa aplicable.</li>
				<li>Para transmitir cualquier material que sea ilícito, fraudulento, difamatorio o que infrinja los derechos de terceros.</li>
				<li>Para intentar obtener acceso no autorizado a cualquier parte del Servicio, otras cuentas o sistemas conectados.</li>
				<li>Para interferir con o interrumpir la integridad o el rendimiento del Servicio.</li>
				<li>Para realizar ingeniería inversa, descompilar o intentar de otra forma extraer el código fuente del Servicio, excepto según lo permita la ley.</li>
			</ul>

			<h2>Propiedad Intelectual</h2>
			<p>
				El Servicio y su contenido original (excluyendo el contenido proporcionado por Usted u otros usuarios),
				sus funciones y funcionalidades son y seguirán siendo propiedad exclusiva de la Empresa y sus
				licenciantes. El Servicio está protegido por derechos de autor, marcas registradas y otras leyes. Nuestras
				marcas no pueden utilizarse en relación con ningún producto o servicio sin Nuestro consentimiento previo
				por escrito.
			</p>

			<h2>Terminación</h2>
			<p>
				Podemos terminar o suspender Su cuenta y acceso al Servicio de inmediato, sin previo aviso ni
				responsabilidad, por cualquier motivo, incluyendo sin limitación si Usted incumple estos Términos.
			</p>
			<p>
				Al terminar, Su derecho a usar el Servicio cesará de inmediato. Usted también puede terminar Su cuenta en
				cualquier momento dejando de usar el Servicio o contactándonos.
			</p>

			<h2>Exención de Garantías</h2>
			<p>
				El Servicio se proporciona &quot;TAL CUAL&quot; y &quot;SEGÚN DISPONIBILIDAD&quot;. La Empresa no ofrece
				garantías, expresas o implícitas, respecto del funcionamiento del Servicio o de la información, contenido
				o materiales incluidos en él. Usted acepta expresamente que el uso que haga del Servicio es bajo su propio
				riesgo.
			</p>

			<h2>Limitación de Responsabilidad</h2>
			<p>
				En la máxima medida permitida por la ley aplicable, en ningún caso la Empresa o sus proveedores serán
				responsables por daños indirectos, incidentales, especiales, consecuentes o punitivos, ni por pérdida de
				ganancias o ingresos, ya sean incurridos directa o indirectamente, ni por pérdida de datos, uso, clientela
				u otras pérdidas intangibles resultantes de Su acceso o uso, o incapacidad de acceder o usar, el Servicio.
			</p>

			<h2>Cambios a Estos Términos</h2>
			<p>
				Nos reservamos el derecho, a Nuestra entera discreción, de modificar o reemplazar estos Términos en
				cualquier momento. Le notificaremos de cualquier cambio publicando los Términos actualizados en esta
				página y actualizando la fecha de &quot;Última actualización&quot; indicada arriba. Su uso continuado del
				Servicio después de dichos cambios constituye Su aceptación de los nuevos Términos.
			</p>

			<h2>Contáctenos</h2>
			<p>Si tiene alguna pregunta sobre estos Términos, puede contactarnos:</p>
			<ul>
				<li>Por email: {CONTACT_EMAIL}</li>
			</ul>
		</div>
	);
}
